import React from "react";
import { useDispatch } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import Swal from "sweetalert2";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { downloadFullReport } from "slices/appointmentSlice";
import DateRangeFilter from "./DateRangeFilter";

// ✅ Utility function to download blob file
function downloadBlobFile(blob, filename = "report.xlsx") {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

const ReportsFilter = ({ onFilter, onReset, setFilterDates, setLoader, showDownloadButton }) => {
    const dispatch = useDispatch();

    const defaultValues = {
        start_date: "",
        end_date: "",
        interpreter_id: "",
    };

    const { handleSubmit, control, reset, getValues } = useForm({
        defaultValues: defaultValues,
    });

    // ✅ Reset button
    const handleResetFields = () => {
        reset(defaultValues);
        onReset(defaultValues);
    };

    // ✅ Search button
    const onSubmit = (data) => {
        onFilter(data);
        setFilterDates(data);
    };

    // ✅ Download report
    const handleDownloadReport = () => {
        setLoader(true);
        const filters = getValues();

        dispatch(
            downloadFullReport(filters, (success, res) => {
                setLoader(false);

                if (!success) {
                    Swal.fire({
                        title: "Error!",
                        text: (res && res.message) || "Failed to download report",
                        icon: "error",
                        confirmButtonColor: "#d33",
                    });
                    return;
                }

                try {
                    if (res instanceof Blob) {
                        downloadBlobFile(res);
                    } else if (res && res.blob) {
                        downloadBlobFile(res.blob, res.filename || "appointments_report.xlsx");
                    } else if (typeof res === "string" && res.startsWith("data:")) {
                        const arr = res.split(",");
                        const mimeMatch = arr[0].match(/:(.*?);/);
                        const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";
                        const bstr = atob(arr[1]);
                        let n = bstr.length;
                        const u8 = new Uint8Array(n);
                        while (n--) u8[n] = bstr.charCodeAt(n);
                        const blob = new Blob([u8], { type: mime });
                        downloadBlobFile(blob);
                    } else if (typeof res === "string") {
                        const a = document.createElement("a");
                        a.href = res;
                        a.target = "_blank";
                        a.download = "";
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                    }

                    Swal.fire({
                        title: "Success!",
                        text: "Report downloaded successfully.",
                        icon: "success",
                        confirmButtonColor: "#3085d6",
                    });
                } catch (err) {
                    console.error("Download error:", err);
                    Swal.fire({
                        title: "Error!",
                        text: "Could not process downloaded file",
                        icon: "error",
                        confirmButtonColor: "#d33",
                    });
                }
            })
        );
    };

    return (
        <div className="content" style={{ minHeight: "auto" }}>
            <div className="row_main_head">
                <h2 className="main_heading">Reports</h2>
            </div>
            <div className="card_table">
                <form className="invoicing_form" onSubmit={handleSubmit(onSubmit)}>
                    {/* <div className="reports row_Invoice">
                        <div className="row-primary">
                            <h2>From Date</h2>
                            <Controller
                                name="start_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image">
                                        <input
                                            type="date"
                                            required
                                            {...field}
                                            value={field.value}
                                            onChange={(e) =>
                                                field.onChange(moment(e.target.value).format("YYYY-MM-DD"))
                                            }
                                        />
                                        <img
                                            src="/images/celender.png"
                                            alt="calendar Icon"
                                            className="custom-icon"
                                        />
                                    </div>
                                )}
                            />
                        </div>

                        <div className="row-primary">
                            <h2>To Date</h2>
                            <Controller
                                name="end_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image">
                                        <input
                                            type="date"
                                            required
                                            {...field}
                                            value={field.value}
                                            onChange={(e) =>
                                                field.onChange(moment(e.target.value).format("YYYY-MM-DD"))
                                            }
                                        />
                                        <img
                                            src="/images/celender.png"
                                            alt="calendar Icon"
                                            className="custom-icon"
                                        />
                                    </div>
                                )}
                            />
                        </div>
                    </div> */}
                    <div className="row-primary">
                    <DateRangeFilter control={control} />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div className="row-primary btns_area row_10 mb-0">
                            <SubmitButton btnText="Search" buttonType="submit" className={"green"} />
                            <SubmitButton
                                buttonType=""
                                className={"lightBlue"}
                                btnText="Reset"
                                onClick={handleResetFields}
                            />
                        </div>
                        {showDownloadButton && (
                            <button
                                type="button"
                                style={{ height: "fit-content" }}
                                className="main_button"
                                onClick={() => handleDownloadReport()}
                            >
                                Download Full Report
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReportsFilter;
